module.exports = __webpack_public_path__ + "img/more_square.8d07b49e.svg";